// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"ed46873e","281":"2152b67a","310":"e24ba653","359":"58b43c12","369":"d29e9cdf","579":"f9c68c5c","605":"2b9c8358","651":"5114e64c","708":"44c1cb9a","825":"e889cb3e","958":"bc83bd94"}[chunkId] + ".chunk.js";
};